import React from 'react';
import styled from 'styled-components';

import MetricPickerPopupConstants from '../constants';
import Row from '../../../../Common/Row';
import CheckmarkIcon from '../images/Checkmark.svg';

const SideBarDiv = styled.div`
  height: calc(${MetricPickerPopupConstants.POPUP_HEIGHT} - 75px);
  border-right: 1px solid var(--color-gainsboro);
  width: ${MetricPickerPopupConstants.SIDE_BAR_WIDTH};
  display: flex;
  flex-direction: column;
  padding-left: ${MetricPickerPopupConstants.PADDING_HORIZONTAL};
  padding-right: ${MetricPickerPopupConstants.PADDING_HORIZONTAL};
  padding-top: ${MetricPickerPopupConstants.PADDING_TOP};
`;

const ListOuterDiv = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
`;

const SideBarContentDiv = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

const ListInnerDiv = styled.div`
  overflow-y: auto;
`;

const ListItem = styled(Row)<{ isSelected: boolean }>`
  background-color: ${(props) =>
    props.isSelected ? 'var(--color-bg-tertiary)' : 'var(--color-bg-primary)'};
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  padding: 8px 10px;

  &:hover {
    background-color: var(--color-bg-muted);
  }
`;

const IconImg = styled.img`
  width: 12px;
  height: 12px;
`;

const CheckMark = () => <IconImg src={CheckmarkIcon} />;

const PopupSideBar = {
  SideBarContentDiv,
  SideBarDiv,
  ListOuterDiv,
  ListInnerDiv,
  ListItem,
  CheckMark,
};

export default PopupSideBar;
